import * as S from './ExtraBedRoomTypeInfo.styles';
import {defaultTheme} from '@stencil/build-theme';

import HermesIconSelector from '../../../../../../shared/components/HermesIconSelector';

export default function ExtraBedRoomTypeInfo({extraPaxPersuasion, isUpSellFlow = false}) {
  const {iconTagName = '', persuasionText = '', colourCodeData = {}} = extraPaxPersuasion[0];

  const {persuasionText: contentPersuasionText = '', colourCodeData: contentColorCodeData = {}} =
    extraPaxPersuasion.length > 1 ? extraPaxPersuasion[1] : {};

  const viewForOldCard = extraPaxPersuasion.length > 1 && !isUpSellFlow;

  return (
    <S.ToolTipTextDiv>
      <S.ToolTipInnerContent viewForOldCard={viewForOldCard}>
        <S.Extra_Bed_Left_Wrap
          viewForOldCard={viewForOldCard}
          isContent={!!persuasionText}
          textColor={colourCodeData?.textColour}
          bgColor={colourCodeData?.bgColour}
          borderColor={colourCodeData?.borderColour}
        >
          <HermesIconSelector
            name={iconTagName || contentPersuasionText ? 'tBed' : 'tStar'}
            styleProps={{
              margin: '0 1rem 0 0',
              fill: colourCodeData?.textColour || defaultTheme.colors.goWhite.base,
            }}
          />
          {persuasionText}
        </S.Extra_Bed_Left_Wrap>
        {contentPersuasionText && (
          <S.Extra_Bed_Right_Wrap
            viewForOldCard={viewForOldCard}
            textColor={contentColorCodeData?.textColour}
            bgColor={contentColorCodeData?.bgColour}
            borderColor={contentColorCodeData?.borderColour}
            isBold={contentColorCodeData?.isBold}
          >
            {contentPersuasionText}
          </S.Extra_Bed_Right_Wrap>
        )}
      </S.ToolTipInnerContent>
    </S.ToolTipTextDiv>
  );
}
